const en = {
  'Тарифы': 'Pricing',
  'Tариф': 'Tariff',
  'месяц': 'month',
  '3 месяца': '3 months',
  '6 месяцев': '6 months',
  '1 год': '1 year',
  'Попробовать': 'Try',
  '/мес': '/mo',
  'бизнес': 'business',
  'постинг': 'posting',
  'Творческий': 'Creative',
  'Продвинутый': 'Advanced',
  'Бизнес': 'Business',
  'Корпоративный': 'Corporate',
  'Бесплатный': 'Free',
  'Канал до 1000 пдп': 'Channel up to 1000 subs',
  'Канал от 1000 пдп': 'Channel from 1000 subs',
  'Цена указана за один канал': 'Price per channel',
  '1 бот': '1 bot',
  '2 бота': '2 bots',
  '5 ботов': '5 bots',
  '10 ботов': '10 bots',
  '50+ ботов': '50+ bots',
  '1 уровень меню': '1 menu level',
  '20 уровней меню': '20 menu levels',
  '1 Автоответ и 1 команда': '1 Auto-reply and 1 command',
  '2 Автоответа и 2 команды': '2 Auto-replies and 2 commands',
  '100 Автоответов и 20 команд': '100 Auto-replies and 20 commands',
  'Безлимит Автоответов и команд': 'Unlimited Auto-replies and commands',
  'Рассылка до 100 чел/сут': 'Broadcast up to 100 users/day',
  'Рассылка до 500 чел/сут': 'Broadcast up to 500 users/day',
  'Рассылка до 1000 чел/сутки в каждом боте': 'Broadcast up to 1000 users/day in each bot',
  'Рассылка до 50 000 чел/сутки в каждом боте': 'Broadcast up to 50,000 users/day in each bot',
  'Рассылка 300 000+ чел/сутки в каждом боте': 'Broadcast 300,000+ users/day in each bot',
  'Добавление кассы и 1 товара': 'Add cashier and 1 product',
  'Добавление кассы и 2 товаров': 'Add cashier and 2 products',
  'Добавление кассы и 20 товаров': 'Add cashier and 20 products',
  'Касса и любое число товаров': 'Cashier and any number of products',
  'Можно добавить в чат и создать саппорт': 'Can be added to a chat and create support',
  'Таргетированные рассылки по базе: по нажатым кнопкам, по поведению и др.': 'Targeted broadcasts by base: by clicked buttons, behavior, etc.',
  'Можно выгружать базу пользователей': 'Can export user base',
  'Отсутствует выгрузка базы пользователей': 'No user base export',
  'Можно добавить администратора и передать права (до 2 сотрудников)': 'Can add admin and hand over rights (up to 2 staff)',
  'Можно добавить администратора и передать права (до 10 сотрудников)': 'Can add admin and hand over rights (up to 10 staff)',
  'Можно добавить администратора и передать права (до 20 сотрудников)': 'Can add admin and hand over rights (up to 20 staff)',
  'Нельзя добавить администратора': 'Cannot add an administrator',
  'Нет продвинутых функций техподдержки': 'No advanced support features',
  'Продвинутая поддержка: Быстрые ответы, Быстрые действия, Разрешения и другое': 'Advanced support: Quick replies, Quick actions, Permissions, etc.',
  'Есть продвинутые функции поддержки: разрешения, быстрые ответы, быстрые действия и т.д.': 'Advanced support features: permissions, quick replies, quick actions, etc.',
  'Отсутствие таргетированных рассылок. Рассылка только по всем пользователям': 'No targeted broadcasts. Broadcasts to all users only',
  'Отсутствует функция "Проверка на подписку"': 'No "Subscription check" feature',
  'Есть функция "Проверка на подписку"': 'Has "Subscription check" feature',
  'Присутствует реклама сервиса: фирменная приписка в стартовом сообщении': 'Service branding present: branded note in the start message',
  'Отсутствует реклама сервиса': 'No service ads',
  'Неограниченное меню': 'Unlimited menu',
  'Доступны все функции без ограничений: проверка подписки, диплинки, утм-метки и др.': 'All features available without limits: subscription check, deep links, UTM tags, etc.'
};

const ru = {};

const translations = { en, ru };
export default translations;
